/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "csv-d1b1ec59--sprite",
  "use": "csv-d1b1ec59--sprite-usage",
  "viewBox": "0 0 38 38",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 38 38\" id=\"csv-d1b1ec59--sprite\">\n  <g>\n    <g>\n      <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M22.086 11a1 1 0 0 1 .707.293l2.914 2.914a1 1 0 0 1 .293.707v11.753a.333.333 0 0 1-.333.333H12.333a.333.333 0 0 1-.333-.333V11.333a.333.333 0 0 1 .333-.333Zm2.581 5H13.333a.333.333 0 0 0-.333.308v5.358a.333.333 0 0 0 .308.334h11.359a.333.333 0 0 0 .333-.309v-5.358a.333.333 0 0 0-.309-.333Zm-5.354 1a1.185 1.185 0 0 1 1.249.917l.007.042v.03a.183.183 0 0 1-.163.182h-.236a.333.333 0 0 1-.3-.186l-.011-.025a.576.576 0 0 0-.567-.344.553.553 0 0 0-.611.509v.022c.005.111.058.31.438.419l.506.136.086.025c.568.176.994.5.994 1.095A1.229 1.229 0 0 1 19.352 21a1.306 1.306 0 0 1-1.369-.967L17.976 20v-.028a.162.162 0 0 1 .143-.161h.275a.325.325 0 0 1 .286.17l.024.05a.727.727 0 0 0 .668.358c.4 0 .651-.226.651-.532 0-.261-.215-.418-.523-.51l-.037-.011-.487-.136c-.837-.215-.984-.719-.984-1.058A1.209 1.209 0 0 1 19.313 17Zm-3.333 0a1.948 1.948 0 0 1 1.385.569l.045.046.006.007a.177.177 0 0 1-.018.235l-.016.013-.184.14a.256.256 0 0 1-.313 0l-.019-.016-.036-.033a1.233 1.233 0 0 0-.83-.316 1.353 1.353 0 0 0 0 2.7 1.245 1.245 0 0 0 .85-.327l.035-.033.018-.016a.227.227 0 0 1 .257-.017l.02.013.235.176.01.008a.143.143 0 0 1 .023.187l-.012.015-.037.04a1.935 1.935 0 0 1-1.414.6A2 2 0 0 1 15.98 17Zm5.516.045a.292.292 0 0 1 .272.186l.008.024.742 2.551.746-2.566.008-.023a.271.271 0 0 1 .229-.172h.328a.17.17 0 0 1 .167.2v.019l-1.075 3.443a.333.333 0 0 1-.291.233h-.183a.333.333 0 0 1-.309-.208l-.009-.026-1.084-3.457v-.016a.158.158 0 0 1 0-.032.16.16 0 0 1 .141-.159h.314Z\" />\n    </g>\n  </g>\n</symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
